import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import ProcessTabsDesktop from "segments/desktop/core-components/process-tabs/process-tabs-desktop/process-tabs-desktop";
import ProcessTabsMobile from "segments/desktop/core-components/process-tabs/process-tabs-mobile/process-tabs-mobile";
import DefaultProps from "./default-props";

const ProcessTabs = withResponsiveHOC(ProcessTabsDesktop, ProcessTabsMobile);

export default ProcessTabs;

ProcessTabs.defaultProps = DefaultProps;
